import { render } from "./SynodicOrbitChartsSwitcher.vue?vue&type=template&id=5c2e4ffc"
import script from "./SynodicOrbitChartsSwitcher.vue?vue&type=script&lang=js"
export * from "./SynodicOrbitChartsSwitcher.vue?vue&type=script&lang=js"

import "./SynodicOrbitChartsSwitcher.vue?vue&type=style&index=0&id=5c2e4ffc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__